import channelApi from '../../../api/channel/channel'

const state = {
    channel_info: {},
    is_symposium_opened: false,//教师控制，开始结束研讨
    is_teacher: false, //判断用户是否是老师
    is_end: false, //判断课程是否过期
    is_bad_connect: false, //判断连接出现问题
    is_buy: false, //是否购买
    //课程信息初始化
    is_init: true,
}

const mutations = {
    change_channel_info(state, ci) {
        state.channel_info = ci;
        state.is_end = ci.course_info.is_end
        state.is_buy = ci.is_buy
    },
    change_symposium_state(state, is_open) {
        // state.is_symposium_opened = is_open;
        state.channel_info.is_symposium_opened = is_open
    },
    change_real_symposium_state(state, is_open){
        state.is_symposium_opened = is_open;
    },
    change_init_state(state, is_open) {
        state.is_init = is_open;
    },
    set_is_teacher(state, is_teacher){
        state.is_teacher = is_teacher
    },
    set_is_bad_connect(state, is_bad_connect){
        state.is_bad_connect = is_bad_connect
    },
    set_is_course_end(state, is_end){
        state.is_end = is_end
    },
    note_change(state, note){
        state.channel_info.lesson_info.description = note
    }
}
const actions = {
    load_channel_info(context, args) {
        channelApi.get_symposium_info(args.lessonId).then(function (ci) {
            if(!ci || !ci.data || !ci.statusText || ci.statusText !=='OK'){
                context.commit('set_is_bad_connect', true)
                return;
            }
            context.commit('change_channel_info', ci.data)
            console.log(ci.data)
            context.commit('change_init_state', false)
            context.commit('change_symposium_state', ci.data.is_symposium_opened)
            context.commit('change_real_symposium_state', ci.data.is_symposium_opened)
            let is_teacher = ci.data.teacher && ci.data.teacher.includes(ci.data.user_info.id)
            context.commit('set_is_teacher', is_teacher)
        }).catch(function () {
            context.commit('set_is_bad_connect', true)
        })
    },
    change_symposium_state(context, is_open){
        context.commit('change_symposium_state', is_open)
    },
    change_real_symposium_state(context, is_open){
        context.commit('change_real_symposium_state', is_open)
    },
    change_init_state(context, is_init){
        context.commit('change_init_state', is_init)
    },
    set_is_bad_connect(context, is_bad_connect){
        context.commit('set_is_bad_connect', is_bad_connect)
    },
    note_change(context, note){
        context.commit('note_change', note)
    },
    post_img(context, file){
        channelApi.post_img(file)
    },
    set_is_course_end(context, is_end){
        context.commit('set_is_course_end', is_end)
    },
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}